export const EmptyResults = () => (
    <section className="px-16 py-32 text-center my-32" data-testid="emptyResultList">
        <h2 className="mb-8">Ingen treff</h2>
        <p className="text-16">Prøv andre søkekriterier eller et annet område.</p>
    </section>
);
